import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";
import available_countries_options from "utils/select_options/available_countries";

import { Main, Dashboard, Select } from "components";
import useCreate from "hooks/useCreate";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;

const VatRateNew = ({
  handleSubmit,
  change,
  pristine,
  invalid,
  history,
}) => {
  const { is_creating, create } = useCreate({
    path: "/vat_rates",
    onSuccess: ({ id }) => {
      history.push(`/vat_rates/${id}`);
    },
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["producer"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const onSubmit = (values) => create(values);

  return (
    <Main
      page={{
        name: "Stawki VAT",
        icon: <ShopIcon />,
        breadcrumbs: [
          {
            name: "Stawki VAT",
            path: "/vat_rates",
          },
          { name: "Dodaj stawkę" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <Dashboard
            footer={
              <>
                <Button
                  type="cancel"
                  onClick={() => history.push("/vat_rates")}
                />
                <Button
                  type="save"
                  text="Utwórz"
                  disabled={pristine || is_creating || invalid}
                  onClick={handleSubmit(onSubmit)}
                />
              </>
            }
          >
            <form
              className="dashboard__form"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <div className="row m-b-10">
                <div className="box-6">
                  <Field
                    name="country_code"
                    label="Kraj"
                    handleChange={(value) => change("country_code", value)}
                    component={SelectField}
                    options={available_countries_options}
                  />
                </div>
                <div className="box-6">
                  <Field
                    name="name"
                    label="Nazwa"
                    component={InputField}
                    type="text"
                  />
                </div>
              </div>
              <div className="row">
                <div className="box-6">
                  <Field
                    name="value"
                    label="Stawka"
                    component={InputField}
                    postfix="%"
                    type="number"
                  />
                </div>
              </div>
            </form>
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.country_code) {
    errors.country_code = "Pole wymagane!";
  }

  if (!values.value) {
    errors.value = "Pole wymagane!";
  }

  if (!values.name) {
    errors.name = "Pole wymagane!";
  }

  return errors;
};

export default reduxForm({
  form: "create-var-rate",
  enableReinitialize: true,
  validate,
})(VatRateNew);
